import { Observable } from 'rxjs';
import { ConfirmationService, SelectItem } from 'primeng/primeng';
import { PromotionCatalogGiftService } from './../../../../../services/promotion/promotion-catalog-gift.service';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCatalogCategoryService } from 'app/services/loyalty/loyalty-catalog-category.service';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
@Component({
  selector: 'app-catalog-gift-detail',
  templateUrl: './catalog-gift-detail.component.html',
  styleUrls: ['./catalog-gift-detail.component.css']
})
export class CatalogGiftDetailComponent implements OnInit {
  catalogId: number;
  giftId: number;
  form: FormGroup;
  catalogGiftFields: any;
  catalogGiftItemFields: any;
  giftTypes: SelectItem[] = [];
  reservationTypes: SelectItem[] = [];
  deliveryTypes: SelectItem[] = [];
  barcodeFormats: SelectItem[] = [];
  giftItemTypes: SelectItem[] = [];
  invalidSubmit = false;
  newImgType: string;
  cancelDetailMsg: string;
  headerMsg: string;
  long_descr: string;
  categoryGiftDesc: SelectItem[] = [];
  brand: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private catalogGiftService: PromotionCatalogGiftService,
    private categoryGiftService: LoyaltyCatalogCategoryService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) { }
  get f() {
    return this.form.controls;
  }
  get levels(): FormArray {
    return this.form.get('levels') as FormArray;
  }
  ngOnInit() {
    this.translate.get([
      'catalog.deleteGift',
      'catalog.headerDeleteGift'
    ]).subscribe(res => {
      this.cancelDetailMsg = res['catalog.deleteGift'];
      this.headerMsg = res['catalog.headerDeleteGift'];
    });
    // Recupero id Catalogo di appartenenza del premio
    this.catalogId = this.activatedRoute.snapshot.params['catalogId'];
    // Verifico che Premio esistente e ne recupero l'id
    this.giftId = this.activatedRoute.snapshot.params['giftId'];
    // Recupero DTO FORMcategory_gift_list
    this.catalogGiftService.getCatlogGiftFields().subscribe(res => this.catalogGiftFields = res);
    this.catalogGiftService.getCatlogGiftItemFields().subscribe(res => this.catalogGiftItemFields = res);
    // Popolo i dropdown
    const obGiftType: Observable<any> = this.catalogGiftService.getCatalogGiftTypes();
    const obReservationType: Observable<any> = this.catalogGiftService.getParamTypes('reservation_type');
    const obDeliveryType: Observable<any> = this.catalogGiftService.getParamTypes('delivery_type');
    const obGiftItemType: Observable<any> = this.catalogGiftService.getGiftItemTypes();
    const obBarcodeType: Observable<any> = this.catalogGiftService.getParamTypes('barcode_type');
    const obCategoryGift: Observable<any> = this.categoryGiftService.getCategoryGifts();
    Observable.zip(
      obGiftType,
      obReservationType,
      obDeliveryType,
      obGiftItemType,
      obBarcodeType,
      obCategoryGift
    ).subscribe(([
      resGiftType,
      resReservationType,
      resDeliveryType,
      resGiftItemType,
      resBarcodeType,
      resCategoryGift
    ]) => {
      // Popolo dropdown Tipologia Premio
      resGiftType.forEach(giftType => this.giftTypes.push({ value: giftType.id, label: giftType.description }));
      // Popolo dropdown Tipologia Prenotazione
      resReservationType.forEach(resType => this.reservationTypes.push({ value: resType.param_code, label: resType.description }));
      // Popolo dropdown Tipologia Consegna
      resDeliveryType.forEach(delType => this.deliveryTypes.push({ value: delType.param_code, label: delType.description }));
      // Popolo dropdown Tipologia Premio Livello
      resGiftItemType.forEach(giType => this.giftItemTypes.push({ value: giType.code, label: giType.description }));
      // Popolo dropdown Formato Barcode
      resBarcodeType.forEach(barcodeFormat => this.barcodeFormats.push({ value: barcodeFormat.param_code, label: barcodeFormat.description }));
      // Popolo dropdown Categoria Premio
      resCategoryGift.forEach(categoryGift => this.categoryGiftDesc.push({ value: categoryGift.id, label: categoryGift.description }));
      // Gestione form
      if (this.giftId) {
        // Se premio esistente, popolo il form
        this.catalogGiftService.getCatalogGiftData(this.giftId).subscribe(giftData => {
          this.form = this.fb.group({
            itm_code: giftData[0]['itm_code'],
            description: giftData[0]['description'],
            img_url: giftData[0]['img_url'],
            img_b64: giftData[0]['img_b64'],
            flg_reserved: giftData[0]['flg_reserved'] === '0' ? true : false,
            type_gift_id: [giftData[0]['type_gift_id'], Validators.required],
            reservation_type: giftData[0]['reservation_type'],
            delivery_type: giftData[0]['delivery_type'],
            itm_code_host: giftData[0]['itm_code_host'],
            category_gift_id: giftData[0]['category_gift_id'],
            long_descr: giftData[0]['long_descr'],
            brand: giftData[0]['brand'],
            levels: new FormArray([])
          });
          // Popolo i form dei Livelli
          this.catalogGiftService.getCatalogGiftItemData(this.giftId).subscribe(itemData => {
            itemData.forEach(item => this.levels.push(this.getLevel(item)));
          });
        });
      } else {
        this.form = this.fb.group({
          category_gift_id: [null],
          brand: [''],
          long_descr: [''],
          itm_code: [''],
          description: [''],
          img_url: [''],
          img_b64: [''],
          flg_reserved: false,
          type_gift_id: [null],
          reservation_type: [''],
          delivery_type: [null],
          itm_code_host: [''],
          levels: new FormArray([])
        });
      }
    });
  }
  getLevel(level?) {
    return this.fb.group({
      id: level ? level.id : null,
      article_code: level ? level.article_code : [''],
      progres: level ? level.progres : [''],
      rdm_points: level ? level.rdm_points : [''],
      rdm_value: level ? level.rdm_value : [''],
      barcode: level ? level.barcode : [''],
      barcode_print: level ? level.barcode_print : [''],
      barcode_format: level ? level.barcode_format : [''],
      itm_type: level ? level.itm_type : ['']
    });
  }
  uploadImg(event?) {
    const reader = new FileReader();
    this.newImgType = event[0].type;
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsBinaryString(event[0]);
  }
  handleReaderLoaded(e) {
    const newBase64Img = btoa(e.target.result);
    if (newBase64Img) {
      this.f.img_url.setValue(null);
      this.f.img_b64.setValue(`data:${this.newImgType};base64,${newBase64Img}`);
    }
  }
  addLevel() {
    this.levels.push(this.getLevel());
  }
  removeLevel(id: number, index: number) {
    if (id) {
      this.catalogGiftService.deleteCatalogGiftItem(id).subscribe(() => this.levels.removeAt(index));
    } else {
      this.levels.removeAt(index);
    }
  }
  goBack() {
    let catalogNameApp = sessionStorage.getItem('catalogName');
    sessionStorage.removeItem('catalogName');
    this.router.navigate([`promotion/catalog/${this.catalogId}/gift`, { catalogName: catalogNameApp }]);
  }
  save() {
    if (
      KoncentroValidators.isEmptyInputValue(this.f.category_gift_id.value)
    ) {
      this.invalidSubmit = true;
      this.f.category_gift_id.setErrors({ 'invalid': true });
    }
    if (
      KoncentroValidators.isEmptyInputValue(this.f.delivery_type.value)
    ) {
      this.invalidSubmit = true;
      this.f.delivery_type.setErrors({ 'invalid': true });
    }
    if (
      KoncentroValidators.isEmptyInputValue(this.f.type_gift_id.value)
    ) {
      this.invalidSubmit = true;
      this.f.type_gift_id.setErrors({ 'invalid': true });
    }
   /* if (
      KoncentroValidators.isEmptyInputValue(this.f.long_descr.value)
    ) {
      this.invalidSubmit = true;
      this.f.long_descr.setErrors({ 'invalid': true });
    }*/
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const giftData = {
      catalog_id: this.catalogId,
      itm_code: this.f.itm_code.value,
      img_url: this.f.img_url.value,
      img_b64: !this.f.img_url.value ? this.f.img_b64.value : null,
      description: this.f.description.value,
      flg_reserved: this.f.flg_reserved.value ? '0' : '1',
      itm_code_host: this.f.itm_code_host.value,
      type_gift_id: this.f.type_gift_id.value,
      reservation_type: this.f.reservation_type.value,
      delivery_type: this.f.delivery_type.value,
      category_gift_id: this.f.category_gift_id.value,
      brand: this.f.brand.value,
      long_descr: this.f.long_descr.value,
    };
    if (this.giftId) {
      this.catalogGiftService.updateCatalogGift(this.giftId, giftData).subscribe(() => this.goBack());
      if (this.levels && this.levels.length > 0) {
        this.levels.controls.forEach(level => {
          const giftItemData = {
            catalog_gift_id: +this.giftId,
            progres: +level.get('progres').value,
            rdm_points: +level.get('rdm_points').value,
            rdm_value: +level.get('rdm_value').value,
            barcode: level.get('barcode').value,
            barcode_print: level.get('barcode_print').value,
            barcode_format: level.get('barcode_format').value,
            article_code: level.get('article_code').value,
            itm_type: level.get('itm_type').value
          };
          if (level.get('id').value) {
            this.catalogGiftService.updateCatalogGiftItem(level.get('id').value, giftItemData).subscribe();
          } else {
            this.catalogGiftService.createCatalogGiftItem(giftItemData).subscribe();
          }
        });
      }
    } else {
      this.catalogGiftService.createCatalogGift(giftData).subscribe(res => {
        if (this.levels && this.levels.length > 0) {
          this.levels.controls.forEach(level => {
            const giftItemData = {
              catalog_gift_id: res.id,
              progres: +level.get('progres').value,
              rdm_points: +level.get('rdm_points').value,
              rdm_value: +level.get('rdm_value').value,
              barcode: level.get('barcode').value,
              barcode_print: level.get('barcode_print').value,
              barcode_format: level.get('barcode_format').value,
              article_code: level.get('article_code').value,
              itm_type: level.get('itm_type').value,
            };
            this.catalogGiftService.createCatalogGiftItem(giftItemData).subscribe();
          });
        }
        this.goBack();
      });
    }
  }
  removeImage() {
    this.f.img_url.setValue('');
    this.f.img_b64.setValue('');
  }
  checkDigitalGift(giftType) {
    if (giftType.value === 2) {
      this.f.delivery_type.setValue('0004');
    }
    this.f.delivery_type.setErrors(null);
  }

  restoreErrorsCategory() {
    this.f.category_gift_id.setErrors(null);
  }

  restoreErrorsTypegift() {
    this.f.type_gift_id.setErrors(null);
  }
  confirmCancelDetail(detail, index) {
    this.confirmationService.confirm({
      header: this.headerMsg,
      message: this.cancelDetailMsg,
      acceptLabel: 'OK',
      accept: () => this.removeLevel(detail, index),
      rejectVisible: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-gift/catalog-gift-detail/catalog-gift-detail.component.ts